import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from '../services/course.service';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  constructor(private courseService: CourseService, private activatedRouter: ActivatedRoute, private router: Router, private toastrService: ToastrService, private userService: UsersService) { }
  public submitted: boolean;
  public userId;
  public title: any = ['Mr', 'Ms', 'Mrs', 'Dr'];
  public paymentTypes: any = ['UPI', 'NEFT'];
  public tenureInMonths: any = [{ label: '3 Months', value: '3m' }, { label: '6 Months', value: '6m' }, { label: '12 Months', value: '12m' }]
  public paymentForm: FormGroup;
  public courseDetails: any;
  public courseId: any;
  public isLoading: boolean = false;
  @Output() public paymentVerified: EventEmitter<any> = new EventEmitter();
  public monthPriceMap = {
    '3m': 300,
    '6m': 500,
    '12m': 700
  }
  @Input() paymentForSubscription: boolean = false;
  ngOnInit(): void {
    this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
    if (!this.paymentForSubscription) {
      this.courseId = this.activatedRouter.params['_value'].courseId;
      this.courseService.getCourse(this.courseId).subscribe(
        (res: any) => {
          this.courseDetails = res.course;
        }
      )
    }
    this.paymentForm = new FormGroup({
      title: new FormControl('Dr', Validators.required),
      first_name: new FormControl('', Validators.required),
      last_name: new FormControl('', Validators.required),
      country_code: new FormControl('91', Validators.required),
      phone: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      payment_type: new FormControl('UPI', Validators.required),
      upi_id: new FormControl(''),
      transaction_id: new FormControl('', Validators.required),
      tenure_in_months: new FormControl('3m'),
      price: new FormControl(this.monthPriceMap['3m'])
    })
  }

  onClickCancel() {
    history.back();
  }

  onClickVerify() {
    this.submitted = true;
    this.isLoading = true;
    if (this.paymentForm.valid) {
      let body = this.paymentForm.value;
      if (this.paymentForSubscription) {
        body['subscription_type'] = 'PRO';
      } else {
        body['course_id'] = this.courseId;
      }
      this.courseService.payForCourse(body).subscribe(
        (res) => {
          if (this.paymentForSubscription) {
            this.userService.upgradeMembership(this.userId, { tenureInMonths: body.tenure_in_months }).subscribe(
              (res) => {
                this.isLoading = false;
                this.paymentVerified.emit(true);
                this.router.navigate([`student/${this.activatedRouter.params['_value'].userId}/dashboard`]);
                this.toastrService.success('Membership will be upgraded within 48hrs.');
              }, (error) => {
                this.isLoading = false;
              }
            )
          } else {
            this.courseService.purchaseCourse(this.courseId, { category: this.courseDetails.category }).subscribe(
              (res) => {
                this.isLoading = false;
                this.router.navigate([`student/${this.activatedRouter.params['_value'].userId}/dashboard`]);
                this.toastrService.success('Course will be added within 48hrs.');
              }, (error) => {
                this.isLoading = false;
              }
            )
          }
        }
      )
    } else {
      this.toastrService.error('Please fill all the fields!')
    }
  }

}
